// extracted by mini-css-extract-plugin
export default {"heading":"_44vAw4IbGeju9ISTV9dvBH","frameResizer":"_3RMSxcp1wv7rtuFDJQQ5vl","frame":"_25vLAfpiysmj1VyMyrBZKL"};